import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import { Button } from "@mui/material";
const TITLE = "كيفية قياس سرعة الانترنت بدقة وسهولة";
const DESCRIPTION =
  "اكتشف كيفية قياس سرعة الانترنت بدقة وسهولة باستخدام أداة قياس سرعة الانترنت. قم بقياس سرعة التحميل والرفع الخاصة بك وتأكد من الحصول على الأداء الأمثل.";
const KEYWORDS =
  "قياس سرعة الانترنت, سرعة الانترنت, اختبار سرعة الانترنت, قياس سرعة التحميل, قياس سرعة الرفع";
const OG_URL = "https://do-calculate.com/calculator/ar/internet-speed";
function InternetSpeed() {
  const [speed, setSpeed] = useState(null);
  const measureSpeed = async () => {
    const fileSizeInBytes = 5000000;
    const start = new Date().getTime();
    const response = await fetch(
      "https://eu.httpbin.org/stream-bytes/5000000",
      {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
        },
      }
    );
    if (response.ok) {
      const end = new Date().getTime();
      const duration = (end - start) / 1000;
      const bitsLoaded = fileSizeInBytes * 8;
      const speedBps = (bitsLoaded / duration).toFixed(2);
      const speedKbps = (speedBps / 1024).toFixed(2);
      const speedMbps = (speedKbps / 1024).toFixed(2);
      setSpeed(`${speedMbps} Mbps`);
    } else {
      alert("يرجى المحاولة لاحقا");
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "14px" }}>أداة قياس سرعة الانترنت</h2>
                <p>
                  أداة قياس سرعة الإنترنت تساعدك على معرفة سرعة اتصالك بالإنترنت
                  بدقة. هذه الأداة تقوم بقياس سرعة التحميل والرفع، مما يساعدك
                  على التأكد من أنك تحصل على السرعة التي تدفع مقابلها لمزود
                  الخدمة.
                </p>
                <h3 style={{ fontSize: "14px" }}>كيفية استخدام الأداة</h3>
                <p>
                  لاستخدام الأداة، اضغط على زر "قياس سرعة الانترنت" وانتظر حتى
                  تكتمل العملية. ستظهر النتيجة بالميجابايت في الثانية (Mbps).
                  تأكد من أنك لا تقوم بتنزيل أو رفع ملفات كبيرة أثناء القياس
                  للحصول على نتيجة دقيقة.
                </p>
                <hr />
              </div>
              <br />
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div
                  className="form-group align-items-center"
                  style={{ justifyContent: "center" }}
                >
                  <Button
                    variant="contained"
                    color="success"
                    onClick={measureSpeed}
                    sx={{
                      fontSize: {
                        md: "17px",
                      },
                    }}
                  >
                   قياس سرعة الانترنت
                  </Button>
                  <div>
                    <br />
                  </div>
                  { speed && (
                    <>
                      <div>
                        <span>سرعة الانترنت الخاصة بك: </span>
                        <b className="alert alert-success">{speed}</b>
                      </div>
                      <br />
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                معلومات حول قياس سرعة الانترنت
              </div>
              <div className="info-section-body">
                <h4>العوامل المؤثرة على سرعة الانترنت</h4>
                <p>
                  قياس سرعة الإنترنت يعتمد على عدة عوامل، بما في ذلك نوع الاتصال
                  بالإنترنت (مثل ADSL، الألياف البصرية، 4G)، والأجهزة المستخدمة،
                  وعدد الأجهزة المتصلة بالشبكة في نفس الوقت. من المهم إجراء
                  قياسات متعددة في أوقات مختلفة للحصول على صورة دقيقة لأداء
                  اتصالك.
                </p>
                <h4>كيف تقوم الأداة بقياس السرعة</h4>
                <p>
                  هذه الأداة تستخدم ملفات تجريبية لقياس الوقت المستغرق لتحميلها
                  أو رفعها، ومن ثم حساب سرعة الإنترنت بناءً على ذلك. تأكد من أنك
                  لا تقوم بتنزيل أو رفع ملفات كبيرة أخرى أثناء القياس للحصول على
                  نتيجة دقيقة.
                </p>
                <h4>نصائح للحصول على أفضل النتائج</h4>
                <ul>
                  <li>
                    قم بقياس السرعة في أوقات مختلفة من اليوم للحصول على متوسط
                    دقيق.
                  </li>
                  <li>
                    تأكد من عدم استخدام الأجهزة الأخرى للإنترنت أثناء القياس.
                  </li>
                  <li>
                    أعد تشغيل جهاز التوجيه الخاص بك قبل القياس للحصول على أفضل
                    أداء.
                  </li>
                </ul>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default InternetSpeed;
